<template>
  <div class="page-wrapper">    
    <div class="page-title">
      <CIcon name="cil-clipboard" /> Add New Case
    </div>
    <CRow>
        <CCol md="12">
            <CCard>
                <CCardHeader>
                    <div class="d-flex justify-content-between align-items-center w-100">
                        <h4 class="card-title mb-0">Case Identity</h4>
                        <small class="text-muted">Step 1 of 4</small>
                    </div>
                </CCardHeader>
                <CCardBody>   
                    <CRow>
                        <CCol sm="4">
                            <CForm>
                                <CSelect
                                    label="Class"
                                    placeholder="Select a one"
                                    :options="options.class"
                                    :value.sync="selected.class"
                                    @change="updateFilters('family')"
                                />      
                            </CForm>
                        </CCol>
                        <CCol sm="4">
                            <CForm>
                                <CSelect
                                    label="Family Name"
                                    placeholder="Select a one"
                                    :options="options.family"
                                    :value.sync="selected.family"
                                    @change="updateFilters('group')"
                                />        
                            </CForm>
                        </CCol>
                        <CCol sm="4">
                            <CForm>
                                <CSelect
                                    label="Group Name"
                                    placeholder="Select a one"
                                    :options="options.group"
                                    :value.sync="selected.group"
                                    @change="updateFilters('identity')"
                                />       
                            </CForm>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="6">
                            <CForm>
                                <CSelect
                                    label="Identity Name"
                                    placeholder="Select an one"
                                    :options="options.identity"
                                    :value.sync="selected.identity"
                                    @change="updateIdentityNames('identity')"
                                />  
                            </CForm>
                        </CCol>
                        <CCol sm="6">
                            <CForm>
                                <CSelect
                                    label="Scientific Name"
                                    placeholder="Select an one"
                                    :options="options.scientific"
                                    :value.sync="selected.scientific"
                                    @change="updateIdentityNames('scientific')"
                                />      
                            </CForm>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="3">
                            <CInput
                                label="Place of Rescue"
                                type="text"
                                v-model="selected.placeOfRescue"
                            />
                        </CCol>
                        <CCol sm="3">
                            <CInput
                                label="District or Sub-Division"
                                type="text"
                                v-model="selected.districtSubdivision"
                            />
                        </CCol>
                        <CCol sm="3">
                            <CSelect
                                label="First Attended By"
                                :options="options.rescuedby"
                                placeholder="Select an option"
                                :value.sync="selected.rescuedBy"
                            />
                        </CCol>
                        <CCol sm="3">
                            <CSelect
                                label="First Brought By"
                                :options="options.broughtBy"
                                placeholder="Select an option"
                                :value.sync="selected.broughtBy"
                            />
                        </CCol>
                        <CCol sm="3">
                            <CSelect
                                label="Zone Name"
                                :options="options.zones"
                                placeholder="Select a zone"
                                :value.sync="selected.zoneName"
                            />
                        </CCol>
                        <CCol sm="3">
                            <CInput
                                label="Date of Admission"
                                type="date"
                                :value="selected.dateOfAdmission"
                                v-model="selected.dateOfAdmission"
                            />
                        </CCol>
                        <CCol sm="6">
                            <CInputFile
                                label="Photographs (minimum 2)"
                                multiple
                                @change="handlePhotoUpload"
                                accept="image/*"
                            />
                        </CCol>
                    </CRow>    
                    <CRow>                        
                        <CCol sm="12" class="text-center" style="min-height:25px">
                            <div>
                                <pulse-loader :loading="loading" color="#2E7D32"></pulse-loader>
                            </div>
                        </CCol>
                    </CRow>                                             
                </CCardBody>
                <CCardFooter class="text-center">
                    <CRow>
                        <CCol sm="6">
                            <CButton type="submit" color="danger" @click="reset()"><CIcon name="cil-reload"/> Reset</CButton>
                        </CCol>
                        <CCol sm="6">
                            <CButton type="submit" color="primary" @click="createNew()"><CIcon name="cil-check-circle"/> Create Record</CButton>
                        </CCol>    
                    </CRow>                                    
                </CCardFooter>   
            </CCard>
        </CCol>
    </CRow>  
    <CRow>
        <CCol md="12">
            <CCard>
                <CCardHeader>
                    <CRow>
                        <CCol sm="6">
                            <h4 id="traffic" class="card-title mb-0">Upload Multiple Records</h4>
                            <div class="small text-muted">Please use csv file in prescribed format to bulk upload the data</div>
                        </CCol>
                    </CRow>                    
                </CCardHeader>
                <CCardBody>   
                    <CRow>
                        <CCol sm="9" class="text-left">
                            <slot name="label">
                                <label class="form-control-label">
                                    1. Download the bulk data upload template by clicking the download button
                                </label>
                            </slot> 
                        </CCol>
                        <CCol sm="3" class="text-left">
                            <a href="https://drive.google.com/file/d/1xDB1BgJnydG6w8m_7VWJB_aEzOObpbQ8/view?usp=share_link" target="_blank">
                                <CButton color="primary" size="sm" @click="downloadTemplate()">
                                        <CIcon name="cil-cloudDownload"/>&nbsp;Download Template
                                </CButton>
                            </a>
                        </CCol>
                    </CRow>         
                    <hr>
                    <CRow>
                        <CCol sm="12" class="text-left">
                            <slot name="label">
                                <label class="form-control-label">
                                    2. Populate the CSV file with cases you want to upload.
                                </label>
                                <div class="small text-danger">Please make sure the formatting of dates and other data are as per the example shown</div>
                            </slot> 
                        </CCol>
                    </CRow>         
                    <hr>
                    <CRow>
                        <CCol sm="9" class="text-left">
                            <slot name="label">
                                <label class="form-control-label">
                                    3. Select a csv file to upload
                                </label>
                            </slot> 
                        </CCol>
                        <CCol sm="3" class="text-left">
                            <CInputFile
                                :custom="false"
                                placeholder="Choose File"
                                @change="handleFileUpload"
                            />    
                        </CCol>
                    </CRow>                                            
                </CCardBody>
                <CCardFooter class="text-center">
                    <CRow>
                        <CCol sm="12">
                            <CButton type="submit" color="primary" @click="uploadBulk()" disabled>Upload Records</CButton>
                        </CCol>    
                    </CRow>                                    
                </CCardFooter>   
            </CCard>
        </CCol>
    </CRow>     
  </div>
</template>

<script>
import axios from 'axios';
import store from '../store';
import { Icon } from 'leaflet';
import GridLoader from 'vue-spinner/src/GridLoader.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
export default {
    name: 'AddCase',
    components: {
            Icon,
            GridLoader,
            PulseLoader,
    },
    mounted() {
        this.getFilters();
        if(store.state.user.assignedZone != null){
            this.selected.zoneName = store.state.user.assignedZone;
        }
    },
    data () {
        return {
            baseURL : store.state.baseURL,
            time : '',
            excelFile : null,
            show: true,
            horizontal: { label:'col-3', input:'col-9' },
            formCollapsed: true,
            photographs: [],
            newStatus : '',
            redIcon : null,
            greenIcon : null,
            loading : false,
            options : {
                outcomes : [],
                zones : [],
                rescuedby:['By WTI','By FD','By WTI & FD','Others'],
                broughtBy:['By WTI','By FD','By WTI & FD','Others'],
                class : [],
                group : [],
                identity : [],
                scientific : [],
                family : [],
                stages : [],
                facilities : [],
                causeOfDisp : [],
            },
            selected : {
                class : null,
                family : null,
                group : null,
                identity : null,
                scientific : null,
                animalDataId : null,
                placeOfRescue : null,
                zoneName : null,
                rescuedBy: null,
                dateOfAdmission : null,
                broughtBy : null,
                districtSubdivision : null,
                
            },    
            errors : []
        }
    },
    methods: {
        handlePhotoUpload(files){
            this.photographs = files;
        },
        handleFileUpload(file, evt){
            this.excelFile = file[0];      
            console.log(file);      
        },
        reset(){
            this.loading = true;
            window.location.reload();
        },
        uploadBulk(){
            this.errors = [];
            if(this.excelFile == null){
                this.errors.push("Please upload a csv file first!");
            }

            if(this.errors.length == 0){
                try{
                    this.loading = true;
                    let formData = new FormData();
                    formData.append('uploadFile', this.excelFile);
                    axios.post(
                        this.baseURL + "records/add-record-bulk",
                        formData,
                        {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            authorization : store.state.token
                        }
                    }

                    )
                    .then(res => {
                        if(res.data.status)
                        {                     
                            this.$notify({
                                group: 'notification',
                                type : 'success',
                                title: 'New record created!',
                                text: res.data.message
                            });
                            this.reset();
                        }
                        else
                        {
                            this.$notify({
                                group: 'notification',
                                type : 'error',
                                title: 'Could not create new record!',
                                text: res.data.message
                            });
                        }
                        this.loading = false;
                    })
                    .catch(err => {
                        this.$notify({
                            group: 'notification',
                            type : 'error',
                            title: 'Could not create new record!',
                            text: 'Something went wrong while creating new record! Please try again later'
                        });
                        console.log(err);
                        this.loading = false;
                    });

                }
                catch(e){
                    this.$notify({
                        group: 'notification',
                        type : 'error',
                        title: 'Could not create new record!',
                        text: 'Something went wrong while creating new record! Please try again later'
                    });
                    console.log(e);
                    this.loading = false;
                }
            }
            else{
                this.showErrors();
            }

        },
        createNew(){
            this.errors = [];
            if(this.selected.identity == null && this.selected.scientific == null){
                this.errors.push("Please select an identity name or scientific name");
            }
            if(this.selected.placeOfRescue == null){
                this.errors.push("Place of Rescue field cannot be empty!")
            }
            if(this.selected.zoneName == null){
                this.errors.push("Place select a zone name!");
            }
            if(this.selected.rescuedBy == null){
                this.errors.push("Place select first attended by option");
            }
            if(this.selected.dateOfAdmission == null){
                this.errors.push("Date of Admission is mandatory for case creation");
            }
            if(this.selected.broughtBy == null){
                this.errors.push("Please seletc who brought");
            }
            if(this.selected.districtSubdivision == null){
                this.errors.push("Please select district or sub-division");
            }
            // if (this.photographs.length < 2) {
            //     this.errors.push("Minimum 2 photographs are required!");
            // }


            if(this.errors.length == 0){
                try{
                    this.loading = true;
                    let formData = new FormData();
                    for (let i = 0; i < this.photographs.length; i++) {
                        formData.append('photographs', this.photographs[i]);
                    }
                    formData.append('class', this.selected.class != null ? this.selected.class : '');
                    formData.append('family', this.selected.family != null ? this.selected.family : '');
                    formData.append('group', this.selected.group != null ? this.selected.group : '');
                    formData.append('identity', this.selected.identity != null ? this.selected.identity : '');
                    formData.append('scientific', this.selected.scientific != null ? this.selected.scientific : '');
                    formData.append('zoneName', this.selected.zoneName != null ? this.selected.zoneName : '');
                    formData.append('rescuedBy', this.selected.rescuedBy != null ? this.selected.rescuedBy : '');
                    formData.append('placeOfRescue', this.selected.placeOfRescue != null ? this.selected.placeOfRescue : '');
                    formData.append('dateOfAdmission', this.selected.dateOfAdmission != null ? this.selected.dateOfAdmission : '');
                    formData.append('broughtBy', this.selected.broughtBy != null ? this.selected.broughtBy : '');
                    formData.append('districtSubdivision', this.selected.districtSubdivision != null ? this.selected.districtSubdivision : '');

                    axios({
                        url : this.baseURL + "records/create-new-record",
                        headers : {
                            authorization : store.state.token,
                            'Content-Type': 'multipart/form-data'
                        },
                        method : "POST",
                        data : formData
                    })
                    .then(res => {
                        if(res.data.status)
                        {                     
                            this.$notify({
                                group: 'notification',
                                type : 'success',
                                title: 'New record created!',
                                text: res.data.message
                            });
                            this.$notify({
                                group: 'notification',
                                type : 'success',
                                title: 'New record created!',
                                text: "Your case ID is " + res.data.id
                            });
                            // this.$router.push({name : 'Edit Case', params : { id : res.data.uid }});
                            window.open(`/edit-case/${res.data.uid}`, '_blank');
                        }
                        else
                        {
                            this.$notify({
                                group: 'notification',
                                type : 'error',
                                title: 'Could not create new record!',
                                text: res.data.message
                            });
                        }
                        this.loading = false;
                    })
                    .catch(err => {
                        this.$notify({
                            group: 'notification',
                            type : 'error',
                            title: 'Could not create new record!',
                            text: 'Something went wrong while creating new record! Please try again later'
                        });
                        console.log(err);
                        this.loading = false;
                    });

                }
                catch(e){
                    this.$notify({
                        group: 'notification',
                        type : 'error',
                        title: 'Could not create new record!',
                        text: 'Something went wrong while creating new record! Please try again later'
                    });
                    console.log(e);
                    this.loading = false;
                }
            }
            else{
                this.showErrors();
            }

        },
        showErrors(){
            for(var i in this.errors){
                this.$notify({
                    group: 'notification',
                    type : 'error',
                    title: 'Could not create new record!',
                    text: this.errors[i]
                });
            }
            
        },
        getFilters(){
            this.filterLoading = true;
            axios({
                url : this.baseURL + "records/filters",
                headers : {
                    authorization : store.state.token
                },
                method : "POST"
            })
            .then(res => {
                if(res.data.status)
                {                     
                    this.options.outcomes = res.data.data.outcomes;
                    this.options.facilities = res.data.data.facilities;
                    this.options.stages = res.data.data.stages;
                    this.options.class = res.data.data.classes;
                    this.options.zones = res.data.data.zones;        
                }
                else
                {
                    this.items = []
                    this.tableLength = 0;
                    this.$notify({
                        group: 'notification',
                        type : 'error',
                        title: 'Important message',
                        text: res.data.message
                    });
                }
                this.filterLoading = false;
            })
            .catch(err => {
                this.$notify({
                    group: 'notification',
                    type : 'error',
                    title: 'Important message',
                    text: 'Error in loading data. Something went wrong!'
                });
                console.log(err);
                this.filterLoading = false;
                return [];
            });

        },
        today(){
            var date = new Date;;
            date = date.toISOString();
            return date.substring(0,10);
        },    
        updateIdentityNames(type){
            console.log(type);
            if(type == 'identity'){
                this.selected.scientific = null;
            }
            else{
                this.selected.identity = null;
            }
        },
        updateFilters(type){
            this.filterLoading = true;

            if(type == 'family'){
                this.selected.family = null;
                this.selected.group = null;
            }
            else if(type == 'group'){
                this.selected.group = null;
            }
            
            axios({
                url : this.baseURL + "records/filters/animal",
                headers : {
                    authorization : store.state.token
                },
                data : {
                    class   : this.selected.class,
                    family  : this.selected.family != null ? this.selected.family : null,
                    group   : this.selected.group != null ? this.selected.group : null,
                    type    : type
                },
                method : "POST"
            })
            .then(res => {
                if(res.data.status)
                {                     
                    this.options.class      = res.data.data.class;
                    this.options.group      = res.data.data.group;
                    this.options.identity   = res.data.data.identity;   
                    this.options.family     = res.data.data.family;
                    this.options.scientific = res.data.data.scientific;     
                }
                else
                {
                    this.$notify({
                        group: 'notification',
                        type : 'error',
                        title: 'Important message',
                        text: res.data.message
                    });
                }
                this.filterLoading = false;
            })
            .catch(err => {
                this.$notify({
                    group: 'notification',
                    type : 'error',
                    title: 'Important message',
                    text: 'Error in loading data. Something went wrong!'
                });
                console.log(err);
                this.filterLoading = false;
                return [];
            });

        },    
    }
}
</script>
<style scoped>
    table, th, td {
        border: 1px solid black;
    }
</style>
